import React, { PropsWithChildren } from 'react';

export const MainContent = (props: PropsWithChildren<any>) => {
  return (
    <div className="app-page-content-main">
      {props.children}
    </div>
  );
};